/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const PLAINTEXT_THEME_TYPE = 'plaintext';
export const UI_DEFAULT_THEME_TYPE = 'ui_default';
export const CUSTOM_THEME_TYPE = 'custom';
